import axios from "axios";

const client = axios.create();

client.interceptors.response.use(
    res => {
        return res;
    },
    err => {
        if (err.response.status === 401) {
            reload();
            window.localStorage.setItem('mvector-logout-event', 'true');
            window.location.href = "/home";
        } 
        else if (err.response.status === 404 || err.response.status === 400) {
            window.location.href = "/notfound";
        }
        else if (err.response.status === 422) {
            document.cookie = "captchaTrigger=true; path=/";
            reload();
        }
        else {
            return err.response;
        }
        // else {
        //     window.location.href = "/notfound";
        //     throw new Error(err.response.data.message);
        // }
    }
)

const reload = () => {
    window.location.reload();
}

export default client;